import React, {useRef, useEffect} from 'react';
import TextField from '@material-ui/core/TextField';

export default function Date_picker(props){

  useEffect(()=>{
    if(props.value==''){props.onChange(setTimeZero(getDate()));}
  },[])

  let value=(props.value=='' || props.value==null)?setTimeZero(getDate()):props.value;
  if(value instanceof Date){value=getDate(value);}
  else if(value.includes('T')==false){value=value.replace(' ','T');}

  if(value!=null && value!=''){value=setTimeHere(value);}
  return(
    <TextField
    id={(props.date_time==true)?"datetime-local":"date"}
    label={props.title}
    value={value}
    onChange={(e)=>{let v=setTimeZero(e.target.value); props.onChange(v);}}
    type={(props.date_time==true)?"datetime-local":"date"}
    size="small"
    InputProps={{ style: { fontSize: undefined } }}
    variant={(props.variant==undefined)?'outlined':props.variant}
    style={{width:'calc(100% - 20px)', marginLeft:'10px'}}
    InputLabelProps={{
      shrink: true,
      style: { fontSize: undefined }
    }}
    disabled={props.disabled}
    step={300}
  />
  )
}


function setTimeHere(dd){
  console.log(dd);
  let d=new Date(dd);
  let n = d.getTimezoneOffset(); d.setHours(d.getHours()-(n/60));
  console.log(getDate(d));
  return getDate(d);
}

function setTimeZero(dd){
  let d=new Date(dd);
  let n = d.getTimezoneOffset(); d.setHours(d.getHours()+(n/60));
  console.log(getDate(d));
  return getDate(d);
}


function getDate(d=null){
  if(d==null){d=new Date();}else{}
  let year = d.getFullYear();
  let month =("0" + (d.getMonth() + 1)).slice(-2);
  let date = ("0" + d.getDate()).slice(-2);
  let hours= ("0" + d.getHours()).slice(-2);
  let minutes=("0" + d.getMinutes()).slice(-2);
  let dd=year+'-'+month+'-'+date+'T'+hours+':'+minutes;
  return dd;
}
